import { Box, Grid, Stack } from "@mui/material";
import React from "react";
import styled from "styled-components";
import CustomTooltip from "src/components/custom-tooltip";

const BadgeBackground = styled(Stack)`
    width: 68px;
    height: 68px;
    padding: 9px;
    border-radius: 14px;
`;

const TooltipTitle = styled.p`
    margin-top: 0;
    margin-bottom: 0.5rem;
    color: ${({ color }) => color};
`;

const TooltipContent = styled.p`
    font-size: 11px;
    font-weight: 200;
    margin: 0;
`;

const BadgeAchieventProfile = ({ achievement }) => {
    if (!achievement) return null;
    const isProd = process.env.ENVIRONMENT_NAME === "prod";
    const setAssetLink = () => {
        if (!isProd) return "https://assets-sit.adadot.com/achievements";
        return "https://assets.adadot.com/achievements";
    };

    const assetLink = setAssetLink();

    return (
        <CustomTooltip
            title={
                <>
                    <TooltipTitle>{achievement.name}</TooltipTitle>
                    <TooltipContent>{achievement.description}</TooltipContent>
                </>
            }
        >
            <Grid item>
                <BadgeBackground direction="column" spacing={-1}>
                    <Box
                        component="img"
                        sx={{
                            height: "58px",
                            width: "58px",
                            borderRadius: "12px",
                        }}
                        alt={achievement.name}
                        src={`${assetLink}/${achievement.category}/${achievement.achievementId}.png`}
                        loading="lazy"
                    />
                </BadgeBackground>
            </Grid>
        </CustomTooltip>
    );
};
export default BadgeAchieventProfile;
